export default __webpack_public_path__ + "static/media/Aguilera.dfee1833.png";